import React from 'react';
import * as PropTypes from 'prop-types';
import { DialogManager } from 'proxiponents';
import IncrementTableContent from './increment-table-content';
import { SHOW_INCREMENT_TABLE } from './increment-table-events';

IncrementTable.propTypes = {
  incrementData: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    minAmount: PropTypes.number.isRequired,
    uptoAmount: PropTypes.number.isRequired
  }).isRequired
  ).isRequired,
  currencySymbol: PropTypes.string.isRequired
};

export default function IncrementTable({ incrementData, currencySymbol }) {
  return (
    <div>
      <DialogManager
        title='Increment Table'
        event={SHOW_INCREMENT_TABLE}
        message={<IncrementTableContent incrementData={incrementData} currencySymbol={currencySymbol} />}
        onClose={() => { }}
      />
    </div>
  );
}